import getUrlParam from 'components/Dashboard/utilities/getUrlParam';

export const filterFiltersOptionDependOnLocation = ({ item, filters }) => {
  const topicId = getUrlParam('topic-id');
  if (item?.options) {
    let checkKeywordList = (condition) => {
      return !condition.keywordLists || condition.keywordLists.some((keywordList) => keywordList === topicId);
    };
    let checkLocation = (condition) => {
      return (
        !condition.locations || condition.locations.some((location) => window.location.pathname.includes(location))
      );
    };

    let getFilterItem = (filterName, filterValue) => {
      return filters.find((item) => item.name === filterName && (!filterValue || item.filterName === filterValue));
    };

    let checkOptionFilterSelected = (condition) => {
      return (
        !condition.optionFilterSelected ||
        condition.optionFilterSelected.every((nationCondition) => {
          let filter = getFilterItem(nationCondition.name);
          if (filter?.optionSelected === nationCondition?.selectedOption) {
            return nationCondition?.condition;
          } else {
            return true;
          }
        })
      );
    };

    let checkOptionFilterSelectedMultiselect = (condition) => {
      return (
        !condition.optionFilterSelectedMultiSelect ||
        condition.optionFilterSelectedMultiSelect.every((value) => {
          const filter = getFilterItem(value.name, value.filterValue);
          return value?.optionsSelected?.some((item) => {
            const anyOptionSelected = filter?.options?.every((option) => !option?.selected);
            const filterOption = filter?.options?.find((option) => option?.name === item);
            return anyOptionSelected || (!anyOptionSelected && !!filterOption && filterOption?.selected);
          });
        })
      );
    };

    //AE: TEMPORARY
    let checkHideIfOptionFilterSelectedMultiselect = (condition) => {
      return (
        !condition.hideIfOptionFilterSelectedMultiSelect ||
        condition.hideIfOptionFilterSelectedMultiSelect.every((value) => {
          const filter = getFilterItem(value.name, value.filterValue);
          const test = value?.optionsSelected?.some((item) => {
            const filterOption = filter?.options?.find((option) => option?.name === item);
            const filterOptionSelected = !!filterOption && filterOption?.selected;
            return filterOptionSelected;
          });
          return !test;
        })
      );
    };

    let checkConditionMapping = {
      keywordLists: checkKeywordList,
      locations: checkLocation,
      optionFilterSelected: checkOptionFilterSelected,
      optionFilterSelectedMultiSelect: checkOptionFilterSelectedMultiselect,
      hideIfOptionFilterSelectedMultiSelect: checkHideIfOptionFilterSelectedMultiselect,
    };
    let checkCondition = (condition) => {
      return Object.keys(condition).every((key) => checkConditionMapping[key](condition));
    };
    let optionsToReturn = item.options.map((option) => {
      if (!option.optionConditionToShow || option.optionConditionToShow.some(checkCondition)) {
        return { ...option, hidden: false };
      } else {
        return { ...option, hidden: true };
      }
    });
    return {
      ...item,
      options: optionsToReturn,
    };
  } else {
    return item;
  }
};
